var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoInfinito(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_158",
    "data-name": "Grupo 158",
    transform: "translate(-134 -1009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-infinito",
    transform: "translate(134 1009)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_4",
    "data-name": "Elipse 4",
    cx: 73,
    cy: 73,
    r: 73,
    fill: "#333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_123",
    "data-name": "Grupo 123",
    transform: "translate(173.307 1065.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_122",
    "data-name": "Grupo 122",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_464",
    "data-name": "Trazado 464",
    d: "M52.589,38.631c-9.672,0-16.072,7.908-21.719,14.886-4.824,5.961-9.38,11.59-14.928,11.59-5.767,0-9.308-5.928-9.308-10.177,0-3.94,3.885-9.666,9.973-9.666a11.349,11.349,0,0,1,9.14,4.971A3.316,3.316,0,0,0,31.4,46.764c-.2-.331-5.068-8.132-14.792-8.132C6.82,38.631,0,47.222,0,54.93c0,7.951,6.547,16.81,15.941,16.81,8.713,0,14.494-7.143,20.085-14.051C41.2,51.3,46.083,45.265,52.589,45.265c3.871,0,6.414,1.313,7.774,4.012a13.4,13.4,0,0,1,1.176,5.909,14.025,14.025,0,0,1-1.566,5.545A6.879,6.879,0,0,1,53.407,64.7,13.391,13.391,0,0,1,42.828,59.27a7.184,7.184,0,0,0-.861-.929,3.316,3.316,0,0,0-4.46,4.906c.06.068.132.157.218.261a19.823,19.823,0,0,0,15.68,7.823c11.157,0,14.766-10.879,14.766-16.19a19.523,19.523,0,0,0-1.886-8.847C64.528,42.8,60.723,38.631,52.589,38.631Z",
    transform: "translate(0 -38.631)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInfinito);
export default __webpack_public_path__ + "static/media/ico-infinito.62703d001cdc4897f455b03a9fe5f03d.svg";
export { ForwardRef as ReactComponent };